export default import.meta.ROLLDOWN_FILE_URL_1nKMmCboA9w846d_4i7g3A